module.exports = "/images/5a33d3422df778bcf88b33918b95f202.png";